<template>
  <v-container>
    <v-layout
      text-center
      wrap
    >
      <v-flex xs12>
        <card-results v-if="showResults"></card-results>
        <card-info v-else-if="!started"></card-info>       
        <card-questions v-else-if="currentPart<=maxParts" :info="test(currentPart,maxParts)"></card-questions>
        <card-thanks v-else></card-thanks>

      </v-flex>      
    </v-layout>
  </v-container>
</template>

<script>
import CardInfo from './cards/CardInfo'
import CardThanks from './cards/CardThanks'
import CardQuestions from './cards/CardQuestions'
import CardResults from './cards/CardResults'
import * as Words from '../tools/wordsList.js'

export default {
  name: 'HelloWorld',
  components: {
    CardInfo,
    CardThanks,
    CardQuestions,
    CardResults
  },
  data: () => ({
      //
      maxParts: 4 ,
      
    }),
  methods:{
    test(num,total){
      return Words.getPart(num,total)
    }
  },
  computed: {
    started(){
      return this.$store.state.started
    },
    showResults(){
      return this.$store.state.showResults
    },
    currentPart(){
      return this.$store.state.currentPart
    }
  }
};
</script>

